/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RedelegateDocumentRequest = {
  delegation_id: number;
  delegatee_email: string;
  delegatee_name: string;
  notification_preference?: RedelegateDocumentRequest.notification_preference;
};
export namespace RedelegateDocumentRequest {
  export enum notification_preference {
    EACH_UPLOAD = 'each_upload',
    ALL_COMPLETE = 'all_complete',
    NONE = 'none',
  }
}

